import { Component, Vue, Prop } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'
import MessageErrorAlert from '@/components/edit/MessageErrorAlert/index.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faClose,
	faLocationDot,
	faScaleBalanced,
	faBuilding,
	faChartPie,
	faChevronRight,
	faChevronLeft,
	faScroll,
} from '@fortawesome/free-solid-svg-icons'

import api from '@/helpers/fetch'
import { log } from 'console'

library.add(
	faClose,
	faLocationDot,
	faScaleBalanced,
	faBuilding,
	faChartPie,
	faChevronRight,
	faChevronLeft,
	faScroll,
)

@Component({
	components: {
		Loader,
		vSelect,
		MessageErrorAlert,
	},
})
export default class AdvancedFiltersModal extends Vue {
	@Prop() subjects!: object[]
	@Prop() companies!: object[]
	@Prop() maxNumOfCompanies!: number
	@Prop() boardCompaniesSet!: any

	searchResult = [] as Array<any>

	form = {
		company_name: null,
		state: null,
		city: null,
		law_firm: null,
		market_sector: null,
		calc_subject: null,
	}

	options = {
		market_sector: [] as Array<any>,
		law_firm: [] as Array<any>,
		city: [] as Array<any>,
		states: getStates(),
	}

	loadingSearch = false
	itemsPerPage = 12
	currentPage = 1
	totalItems = 0
	totalPages = 0
	async load() {
		this.loadingSearch = true
		this.clearSelected()
		this.setCanAddCompany()

		const filters: any[] = []

		Object.entries(this.form).forEach((array) => {
			let [key, value]: any = array

			if (value) {
				if (typeof value === 'string') {
					value = value.trim()
				}

				filters.push(`${key}=${encodeURIComponent(value)}`)
			}
		})

		this.loadingSearch = true

		if (filters && filters.length) {
			const url =
				`/api/thermometer/collections/search?items=${this.itemsPerPage}&page=${this.currentPage}&` +
				filters.join('&')

			const res = await api.get(url)

			if (res.ok) {
				this.searchResult = res.data.thermometer

				this.totalItems = res.data.thermometer_aggregate.aggregate.count
				this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
			}
		} else {
			this.searchResult = []
		}

		this.loadingSearch = false
	}

	loadingOptions = false
	async start() {
		if (this.options.market_sector && !this.options.market_sector.length) {
			this.loadingOptions = true
			await this.loadOptions()
			this.loadingOptions = false
		}
	}

	async loadOptions() {
		const res = await api.get(
			'/api/thermometer/collections/options?options=city,market_sector,law_firm',
		)

		this.options.market_sector = res.data.options.market_sector
		this.options.law_firm = res.data.options.law_firm
		this.options.city = res.data.options.city
		this.loadingOptions = false
	}

	canGoNext() {
		return this.currentPage < this.totalPages
	}

	nextPage() {
		if (!this.canGoNext()) return
		this.currentPage++
		this.clearSelected()
		this.load()
	}

	canGoPrev() {
		return this.currentPage > 1
	}

	prevPage() {
		if (!this.canGoPrev()) return
		this.currentPage--
		this.clearSelected()
		this.load()
	}

	fuseSearch(options, search) {
		const searched = onSearch(options, search)
		return searched
	}

	getSelectedItemsByCompany() {
		const selectedItemsByCompany = {}
		this.selectedItems.forEach((item) => {
			const companyName = item.company_name.trim()
			selectedItemsByCompany[companyName] =
				selectedItemsByCompany[companyName] || []

			selectedItemsByCompany[companyName].push(item)
		})

		return selectedItemsByCompany
	}

	toggleEntry(entry) {
		const newValue = !entry.selected
		this.setCanAddCompany(entry)

		if (newValue) {
			if (this.canAddCompany) {
				Vue.set(entry, 'selected', newValue)
			}
		} else {
			Vue.set(entry, 'selected', newValue)
		}

		this.setCanAddCompany(entry)
	}

	canAddCompany: null | boolean = null
	canSendToBoard = true
	errorMessageMaxCompanies = `Máximo de ${this.maxNumOfCompanies} empresas atingido`
	onShown() {
		this.setCanAddCompany()
	}

	hidden() {
		this.clearSelected()
		this.$emit('hidden')
	}

	setCanAddCompany(entry?) {
		Vue.set(this, 'canAddCompany', this.checkCanAddCompany(entry))
	}

	checkCanAddCompany(entry?) {
		const boardSize = this.boardCompaniesSet.size
		const selectedItemsByCompany = this.getSelectedItemsByCompany()

		const selectedCompanies = Object.keys(selectedItemsByCompany)
		const numCompaniesLeft =
			this.maxNumOfCompanies - boardSize - selectedCompanies.length

		if (entry) {
			const companyName = entry.company_name.trim()
			if (
				selectedCompanies.includes(companyName) &&
				this.boardCompaniesSet.has(companyName)
			) {
				return true
			}
		}

		if (numCompaniesLeft === 0) {
			return false
		}

		return true
	}

	clearForm() {
		this.form.company_name = null
		this.form.state = null
		this.form.city = null
		this.form.law_firm = null
		this.form.market_sector = null
		this.form.calc_subject = null

		this.searchResult = []
	}

	clearSelected() {
		this.searchResult.forEach((item) => {
			Vue.set(item, 'selected', false)
		})
	}

	reset() {
		this.clearForm()
		this.currentPage = 1
		this.loadingSearch = false
		this.loadingOptions = false
		this.clearSelected()
	}

	get selectedItems() {
		return this.searchResult.filter((item) => {
			return item.selected
		})
	}

	done() {
		this.$emit('done', this.selectedItems)
		this.$bvModal.hide('termometro-filtros-avancados')
	}
}

function onSearch(allItems, search) {
	if (typeof search !== 'string') return
	const searchArray = search?.split(' ')

	const result = allItems.filter((item) => {
		if (item) {
			const name = removeAccents(item.name.toLowerCase())

			return searchArray.every((string) => {
				return name.includes(removeAccents(string.toLowerCase()))
			})
		}

		return false
	})

	return result
}

function removeAccents(str) {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

function getStates() {
	return [
		{ id: 1, name: 'SP' },
		{ id: 2, name: 'RJ' },
		{ id: 3, name: 'MG' },
		{ id: 4, name: 'AC' },
		{ id: 5, name: 'AL' },
		{ id: 6, name: 'AM' },
		{ id: 7, name: 'AP' },
		{ id: 8, name: 'BA' },
		{ id: 9, name: 'CE' },
		{ id: 10, name: 'DF' },
		{ id: 11, name: 'ES' },
		{ id: 12, name: 'GO' },
		{ id: 13, name: 'MA' },
		{ id: 14, name: 'MG' },
		{ id: 15, name: 'MS' },
		{ id: 16, name: 'MT' },
		{ id: 17, name: 'PA' },
		{ id: 18, name: 'PB' },
		{ id: 19, name: 'PE' },
		{ id: 20, name: 'PI' },
		{ id: 21, name: 'PR' },
		{ id: 22, name: 'RJ' },
		{ id: 23, name: 'RN' },
		{ id: 24, name: 'RO' },
		{ id: 25, name: 'RR' },
		{ id: 26, name: 'RS' },
		{ id: 27, name: 'SC' },
		{ id: 28, name: 'SE' },
		{ id: 29, name: 'SP' },
		{ id: 30, name: 'TO' },
	]
}
